import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_031.jpg';
page.images = [
  {
    imageId: 'page031_zoom0',
    rectangle: {
      x: 654,
      y: 1442,
      width: 1132,
      height: 618,
    },
    imageSrc: 'images/page031/031 2.jpg',
  },
  {
    imageId: 'page031_zoom1',
    rectangle: {
      x: 660,
      y: 272,
      width: 1126,
      height: 838,
    },
    imageSrc: 'images/page031/031 1.jpg',
  },
];
page.games = [
  {
    id: 'page031_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1401,
    },
    item: {
      id: 'page031_game11',
    },
    rectangle: {
      id: 'page031_rect1',
    },
  },
  {
    id: 'page031_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 221,
    },
    item: {
      id: 'page031_game10',
    },
    rectangle: {
      id: 'page031_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page031_rect0',

    tooltip: '',

    linked: ['page031_game10'],
    x: 132,
    y: 221,
    width: 515,
    height: 908,
  },
  {
    id: 'page031_rect1',

    tooltip: '',

    linked: ['page031_game11'],
    x: 137,
    y: 1401,
    width: 508,
    height: 622,
  },
];
export default page;
